module.exports = __webpack_public_path__ + "static/media/icon_defis_fusee.12593a52.svg";